export default "__VITE_ASSET__CbYpfA4E__"